import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';

// Expects match_res to be a JSON string with a single key/value
export const MatchCellRenderer = ({ value, data }) => {
  let tooltip = '';
  let status = 'MATCH';

  if (!data?.matchRes) return '';

  let matchRes =JSON.parse(data.matchRes);
  if (matchRes?.MISMATCH) {
    status = 'MISMATCH';
    tooltip = matchRes.MISMATCH + '\n';
  }

  for (const [key, value] of Object.entries(matchRes)) {
    if (key.includes('MISSING')) {
      status = status !== 'MISMATCH' ?  'MISSING' : status; // Mismatch is more severe than Missing
      tooltip += value + '\n';
    }
  }

  tooltip = tooltip.trimEnd();

  if (status === 'MATCH') {
    tooltip = 'Matching';
  }

  return (
    <Tooltip arrow
      title={
        tooltip.split('\n').map((line, idx) => (
          <div key={idx}>{line}</div>
        ))
      }
    >
      <Box style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
        {status === 'MATCH' ? (
          <FontAwesomeIcon icon={fas.faCheck} style={{ color: 'green' }} />
        ) : status === 'MISMATCH' ? (
          <FontAwesomeIcon icon={fas.faTimes} style={{ color: 'red' }} />
        ) : (
          <FontAwesomeIcon icon={fas.faExclamationTriangle} style={{ color: 'orange' }} />
        )}
      </Box>
    </Tooltip>
  );
};
